import AuthService from "@/lib/auth";
import { toast } from "sonner";

export interface CallResponse {
  success: boolean;
  message?: string;
  callId?: string;
  logId?: number;
}

const CallService = {
  /**
   * Initiates an immediate outbound call via Amazon Connect
   */
  async makeCallNow(patientId: string, questionnaireId?: string, notes?: string): Promise<CallResponse> {
    const loadingToast = toast.loading("Initiating call via Amazon Connect...");
    try {
      const response = await AuthService.callNow({
        patient_id: patientId,
        questionnaire_id: questionnaireId,
        notes: notes
      });
      
      toast.dismiss(loadingToast);
      toast.success("Call initiated successfully");
      
      return {
        success: true,
        callId: response.contactId,
        logId: response.log?.id
      };
    } catch (error: any) {
      toast.dismiss(loadingToast);
      const errorMessage = error.message || "Failed to initiate call";
      toast.error(errorMessage);
      return {
        success: false,
        message: errorMessage,
      };
    }
  },

  /**
   * Schedules a call for a future time
   */
  async scheduleCall(patientId: string, scheduledTime: string, questionnaireId?: string, notes?: string): Promise<CallResponse> {
    const loadingToast = toast.loading(`Scheduling call for ${new Date(scheduledTime).toLocaleString()}...`);
    try {
      const response = await AuthService.scheduleCall({
        patient_id: patientId,
        scheduled_at: scheduledTime,
        questionnaire_id: questionnaireId,
        notes: notes
      });
      
      toast.dismiss(loadingToast);
      toast.success("Call scheduled successfully");
      
      return {
        success: true,
        message: "Call scheduled successfully",
        logId: response.log?.id
      };
    } catch (error: any) {
      toast.dismiss(loadingToast);
      const errorMessage = error.message || "Failed to schedule call";
      toast.error(errorMessage);
      return {
        success: false,
        message: errorMessage,
      };
    }
  }
};

export default CallService;
